import { AbstractDataProvider } from "./AbstractDataProvider";
import { Student, studentsProvider } from "./studentsProvider";
import { GetListParams, GetListResult } from "react-admin";
import { getAuthenticatedServerClient } from "../api/server.api";
import { applyFilter, applyPagination, applySort } from "../backoffice.utils";

export interface CourseParticipant {
  studentId: string;
  bookedQuoteId: string;
}

class CourseParticipantsProvider extends AbstractDataProvider<Student> {
  async getAllForCourse(courseId: string): Promise<Array<CourseParticipant>> {
    const serverClient = await getAuthenticatedServerClient();
    return serverClient.getCourseParticipants({ params: { id: courseId } });
  }

  async getList(_resource: string, { pagination, sort, filter }: GetListParams): Promise<GetListResult<Student>> {
    const { courseId, ...clientSideFilter } = filter;
    if (!courseId) {
      throw new Error(`Unexpected filter: ${JSON.stringify(filter)} -- expected: {"courseId": ...}`);
    }
    const courseParticipants = await this.getAllForCourse(courseId);
    const studentIds = courseParticipants.map((it) => it.studentId);
    const { data: students } = await studentsProvider.getMany("students", { ids: studentIds });
    return applyPagination(applySort(applyFilter(students, clientSideFilter), sort), pagination);
  }
}

export const courseParticipantsProvider = new CourseParticipantsProvider();
